/**
 * Physical format of a printed card.
 *
 * Both orientations use the classic 3.5 x 2 business-card ratio and are
 * authored at a generous pixel size so the layout can use real print-scale
 * typography. Anything smaller is produced by uniformly scaling the whole
 * design down, never by reflowing it into a cramped box.
 */
export type Orientation = 'horizontal' | 'vertical';

export const H_WIDTH = 640;
export const H_HEIGHT = 366;
export const V_WIDTH = 440;
export const V_HEIGHT = 770;

export function cardSize(orientation: Orientation): { width: number; height: number } {
  return orientation === 'horizontal'
    ? { width: H_WIDTH, height: H_HEIGHT }
    : { width: V_WIDTH, height: V_HEIGHT };
}

/** Which profile fields are rendered on the card. */
export interface CardFieldVisibility {
  avatar: boolean;
  bio: boolean;
  nip05: boolean;
  website: boolean;
  lud16: boolean;
  badges: boolean;
}

/**
 * A lightning address and a badge row are both things people opt *into*
 * printing, so they start off; everything else is standard card material.
 */
export const DEFAULT_FIELD_VISIBILITY: CardFieldVisibility = {
  avatar: true,
  bio: true,
  nip05: true,
  website: true,
  lud16: false,
  badges: false,
};
